import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Header from './common/Header';
import Footer from './common/Footer';
import ContactPage from "./pages/ContactPage"
import PlusCabsAbout from './pages/AboutUs';
import OurFleet from './pages/Ourfleet';
import PlusCabsAuth from './common/Signin';
import ScrollToTop from './components/ScrollToTop';
import ServiceVehiclesPage from './pages/ServiceVehiclesPage';

import AirportBookingPage from './components/BookingForms/AirportBookingForm';
import OutstationBookingPage from './components/BookingForms/OutstationBookingForm';
import LocalBookingPage from './components/BookingForms/LocalBookingForm';
import BookingConfirmationPage from './components/BookingForms/BookingConfirmationPage';

import TourPackages from "./pages/TourPackages";
import BookingPage from './pages/BookingPage';
import FloatingButtons from './common/FloatingButtons'; // Import the floating buttons
import SuvRentalPage from './pages/Suv/SuvRentalPage';
import TempoTravellerRentalPage from './pages/Suv/TempoTravellerRentalPage';
import UrbaniaRentalPage from './pages/Suv/UrbaniaRentalPage';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <FloatingButtons /> {/* Add floating buttons here */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="services/airport-transfer" element={<ServiceVehiclesPage tripType="airport" />} />
        <Route path="services/local-packages" element={<ServiceVehiclesPage tripType="local" />} />
        <Route path="services/outstation" element={<ServiceVehiclesPage tripType="outstation" />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="about" element={<PlusCabsAbout />} />
        <Route path="fleet" element={<OurFleet />} />
        <Route path="signin" element={<PlusCabsAuth />} />

        <Route path="/booking/airport" element={<AirportBookingPage />} />
        <Route path="/booking" element={<BookingPage />} />
        <Route path="/booking/outstation" element={<OutstationBookingPage />} />
        <Route path="/booking/local" element={<LocalBookingPage />} />
        <Route path="/booking-confirmation" element={<BookingConfirmationPage />} />

        <Route path="/tour-packages" element={<TourPackages />} />
        <Route path="/vehicles/suv" element={<SuvRentalPage />} />
        <Route path="/vehicles/tempo-traveller" element={<TempoTravellerRentalPage />} />
        <Route path="/vehicles/urbania" element={<UrbaniaRentalPage />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
